export class proposalData {
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    email: string = '';
    gender: string = '';
    sumInsured: string = '';
    title : string = '';
    address1 : string = '';
    dob : string = '';
    // adhaar : string = '';
    pincode : string = '';
    city : string = '';
    state : string = '';
    insuredTitle : string = '';
    insuredFirstName : string = '';
    insuredLastName : string = '';
    insuredRelation : string = '';
    insuredDob : string = '';
    insuredGender : string = '';
    nomineeName : string = '';
    nomineeRelation : string = '';
    nomineeDob : string = '';
    prospectId : string = '';
    quoteId : string = '';

    constructor() {
    }
}